<template>
  <div>
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div class="cards-container row d-flex wrap align--start" v-if="!this.$store.getters.isLoading">
      <div v-if="subscriptionPack.name && subscriptionPack.amount && untilDate" class="flex xs12">
        <va-card
          :title="subscriptionPack.name"
        >
          {{ $t('payment.purchasePack') }} - {{ subscriptionPack.name }} {{ $t('payment.with') }} {{ subscriptionPack.amount }} {{ $t('payment.packWillBe') }} {{ untilDate }}
          <ul>
            <li>{{ $t('payment.packPrice') }}: <b>{{getPackPrice + getCurrencySign}}</b></li>
            <li>{{ $t('payment.tax') }}: {{subscriptionPack.isTax ? '24%' : '0%'}}</li>
            <li>{{ $t('payment.taxPrice') }}: <b>{{subscriptionPack.taxPrice + getCurrencySign}}</b></li>
            <li>{{ $t('payment.finalAmount') }}: <b>{{getFinalPackPrice + getCurrencySign}}</b></li>
          </ul>
        </va-card>
      </div>
      <div v-if="clientSecret && getFinalPackPrice" class="flex xs12">
        <CardPayment @payment="paymentStatus" :clientSecret="clientSecret" :amount="getFinalPackPrice"></CardPayment>
      </div>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
import CardPayment from '@/components/payment/CardPayment.vue'

export default {
  components: { SwappingSquaresSpinner, CardPayment },
  mixins: [errorHandlerMixin],
  name: 'Payment',
  data () {
    return {
      subscriptionPack: {},
      clientSecret: null,
      title: '',
      stripeCustomerId: '',
    }
  },
  methods: {
    async initSubscriptionPack (pack) {
      this.subscriptionPack = pack
    },
    async getClientSecret () {
      await this.$store.dispatch('getClientSecret', {
        amount: this.getFinalPackPrice,
        subscriptionPackId: this.$route.params.subscriptionPackId,
      }).then((resp) => {
        this.clientSecret = resp.data.message.clientSecret
        this.stripeCustomerId = resp.data.message.stripeCustomerId
        this.$store.commit('setLoading', false)
      }).catch(error => {
        this.errorHandler(error.response)
        this.$store.commit('setLoading', false)
      })
    },
    paymentStatus (state, resp) {
      if (state) {
        this.completePaymentPack(resp)
      }
    },
    async completePaymentPack (resp) {
      await this.$store.dispatch('completePaymentPack', {
        amount: this.getFinalPackPrice,
        subscriptionPackId: this.$route.params.subscriptionPackId,
        stripeCustomerId: this.stripeCustomerId,
      }).then((resp) => {
        this.$router.push({
          name: 'payment-completed-pack',
          params: { paymentId: resp.data.message.paymentId },
        })
      }).catch(error => {
        this.errorHandler(error.response)
      })
    },
  },
  computed: {
    untilDate () {
      const currentDate = new Date()
      const futureDate = new Date(currentDate)
      const period = this.subscriptionPack.period
      futureDate.setMonth(currentDate.getMonth() + period)
      return futureDate.toLocaleDateString()
    },
    getPackPrice () {
      return parseFloat((this.subscriptionPack.price).toFixed(2))
    },
    getFinalPackPrice () {
      const subscriptionPackPrice = this.subscriptionPack.price
      const taxPrice = this.subscriptionPack.taxPrice
      if (this.subscriptionPack.isTax) {
        return parseFloat((subscriptionPackPrice + taxPrice).toFixed(2))
      }
      return parseFloat(subscriptionPackPrice.toFixed(2))
    },
    getCurrencySign () {
      return this.$store.getters.authenticationData.currency.currencySign
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getSubscriptionPack', this.$route.params.subscriptionPackId)
      .then((resp) => this.initSubscriptionPack(resp.data.message))
      .then(() => this.getClientSecret())
      .catch(error => {
        this.errorHandler(error.response)
        this.$store.commit('setLoading', false)
      })
    this.$store.commit('setLoading', false)
  },
}
</script>

<style scoped type="scss">
  $icon-size: 3rem;
  $icon-color: #d8d8d8;
  $main-color: #f85e6a;

  .pricing-table {
    display: table;
    width: 100%;

    .pricing-option {
      width: 28%;
      background: white;
      float: left;
      padding: 2%;
      text-align: center;
      transition: all 0.3s ease-in-out;

      &:nth-child(even) {
        margin: 0 2%;
      }

      &:hover {
        cursor: pointer;
        box-shadow: 0 2px 30px rgba(0, 0, 0, 0.3);
        transform: scale(1.04);

        i,
        h1,
        span,
        b {
          color: $main-color;
        }

        .front {
          opacity: 0;
          visibility: hidden;
        }

        .back {
          opacity: 1 !important;
          visibility: visible !important;

          a.button {
            transform: translateY(0) !important;
          }
        }
      }

      hr {
        border: none;
        border-bottom: 1px solid #f0f0f0;
      }

      i {
        font-size: $icon-size;
        color: $icon-color;
        transition: all 0.3s ease-in-out;
      }

      h1 {
        margin: 10px 0;
        color: #212121;
        transition: all 0.3s ease-in-out;
      }

      p {
        color: #999999;
        padding: 0 10px;
        line-height: 1.3;
      }

      .price {
        position: relative;

        .front {
          span.price {
            font-size: 2rem;
            text-transform: uppercase;
            margin-top: 20px;
            display: block;
            font-weight: 700;
            position: relative;

            b {
              position: absolute;
              font-size: 1rem;
              margin-left: 2px;
              font-weight: 600;
            }
          }
        }

        .back {
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease-in-out;

          a.button {
            background: $main-color;
            padding: 15px 20px;
            display: inline-block;
            text-decoration: none;
            color: white;
            position: absolute;
            font-size: 13px;
            top: -5px;
            left: 0;
            right: 0;
            width: 150px;
            margin: auto;
            text-transform: uppercase;
            transform: translateY(20px);
            transition: all 0.3s ease-in-out;

            &:hover {
              background: darken($main-color, 10%);
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    .pricing-table {
      .pricing-option {
        padding: 5%;
        width: 90%;

        &:nth-child(even) {
          margin: 30px 0 !important;
        }
      }
    }
  }
</style>
